import React from "react";
import { Alert, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

// Copy used when the API omits the message field.
// Source: ESTRATEGIA-MONETIZACION.md §3 — "regla de empujón a upgrade"
const FALLBACK_MSG =
  "Con 4 bloques de estudiantes pagarías $100.000 extra; el plan Academia te da " +
  "200 estudiantes + honorarios + multi-sede por $100.000 más. ¿Mejoramos tu plan?";

/**
 * UpgradeNudge — reutilizable en PlanPage y en el handler global de error 402.
 *
 * Props:
 *   suggest_upgrade {boolean}  — si false, no renderiza nada
 *   upgrade_to      {string}   — slug del plan sugerido (informativo)
 *   message         {string}   — copy del API (preferencia); fallback = ESTRATEGIA §3
 *   onUpgrade       {function} — callback custom; si omitido, navega a /:slug/app/plan
 *   onDismiss       {function} — si se pasa, muestra botón de cierre
 */
function UpgradeNudge({ suggest_upgrade, upgrade_to, message, onUpgrade, onDismiss }) {
  const navigate = useNavigate();
  const params = useParams();

  if (!suggest_upgrade) return null;

  function handleUpgrade() {
    if (onUpgrade) {
      onUpgrade();
    } else {
      const slug = params.slug ?? "";
      navigate(`/${slug}/app/plan`, { state: { activeTab: "upgrade" } });
    }
  }

  return (
    <Alert
      variant="warning"
      className="d-flex align-items-start gap-2 flex-wrap"
      role="alert"
      onClose={onDismiss}
      dismissible={Boolean(onDismiss)}
    >
      <div className="flex-grow-1">
        <Alert.Heading className="h6 mb-1">Sugerencia de plan</Alert.Heading>
        <p className="mb-2 small">{message || FALLBACK_MSG}</p>
        {upgrade_to && (
          <p className="mb-0 small text-muted">Plan sugerido: {upgrade_to}</p>
        )}
      </div>
      <Button
        size="sm"
        variant="warning"
        className="fw-semibold text-nowrap"
        onClick={handleUpgrade}
        aria-label="Mejorar mi plan de suscripción"
      >
        Mejorar plan
      </Button>
    </Alert>
  );
}

export { UpgradeNudge };
